module.exports = __webpack_public_path__ + "static/img/main3-bg-3.719e87b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main3-bg-3.png
// module id = 7xi7
// module chunks = 7